import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import router from '../router/index';

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    token: null,
    user: null,
    login_time: null
  },

  getters: {
    getUserToken(state) {
      return state.token;
    },
    isAuthenticated(state) {
      return state.token !== null && state.user !== null;
    }
  },

  mutations: {
    async loginUser(state, { user, token }) {
      state.token = token;
      state.user = user;
      state.login_time = new Date().getTime();
      router.push('/dashboard');
    },
    logoutUser(state) {
      state.token = null;
      state.user = null;
      state.login_time = null;
      router.push('/dashboard');
    }
  },
  actions: {
    logoutUser(context) {
      context.commit('logoutUser')
    },
    loginUser(context, params) {
      context.commit('loginUser', params)
    }
  },
});